import React from 'react';
import { useTranslation } from 'react-i18next';

import { PetItem } from './common';

import styles from './IneligiblePetsList.module.css';

const IneligiblePetsList = ({
  ineligiblePets = [],
  ineligiblePetsCounts = {},
  isCompleted = false,
}) => {
  const { t } = useTranslation('petDemos');

  if (!isCompleted) {
    return (
      <span className={styles.petsIneligibleDescriptionTbd}>
        {t('policyInformation.toBeDetermined')}
      </span>
    );
  }

  if (isCompleted && !ineligiblePets.length) {
    return (
      <span className={styles.policyPetsStatusValue}>
        {t('policyInformation.none')}
      </span>
    );
  }

  const countText = [];
  if (ineligiblePetsCounts.cats > 0) {
    countText.push(t('policyInformation.cats', {
      count: ineligiblePetsCounts.cats,
    }));
  }
  if (ineligiblePetsCounts.dogs > 0) {
    countText.push(t('policyInformation.dogs', {
      count: ineligiblePetsCounts.dogs,
    }));
  }

  return (
    <div className={styles.policyPetsStatusValueList}>
      <span className={styles.policyPetsStatusValue}>
        {countText.join(', ')}
      </span>

      {ineligiblePets.map((pet) => (
        <PetItem
          key={`ineligible-${pet.Id}`}
          isRemoved
          label={pet.Name}
          specie={pet.Specie}
        />
      ))}
    </div>
  );
};

export { IneligiblePetsList };
